import { useState } from "react";

import { TerminalPasswordCreateForm } from "src/app/features/TerminalPassword/components/forms/TerminalPasswordCreateForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { GenerateButton } from "../../../../components/FeatureButtons/GenerateButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";

export const TerminalPasswordCreateFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.TERMINAL_PASSWORD, "canWrite");
    const hasAccess = canAccess(ResourceName.TERMINAL_PASSWORD, "canRead");

    return (
        <FPage>
            {hasAccess ? (
                <>
                    <FPageHeader>
                        <PageTitle translationKey="page.title.TerminalPasswordCreateFormPage" />
                        {hasWriteAccess && (
                            <ActionBar>
                                <GenerateButton onClick={triggerFormSubmit} />
                            </ActionBar>
                        )}
                    </FPageHeader>
                    <FPageContent>
                        <TerminalPasswordCreateForm runSubmit={runSubmit} />
                    </FPageContent>
                </>
            ) : (
                <NoAccessLayout />
            )}
        </FPage>
    );
};
